export default __webpack_public_path__ + "static/media/all-top-corners-rounded.0c71a23b.webp";